type DescriptionListItem = {
  label: string,
  value: React.ReactNode
}

type DescriptionListProps = {
  items: DescriptionListItem[]
}

const styles = {
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(max(30%, 250px), 1fr))',
    gap: '24px',
    margin: 0
  },
  label: {
    color: '#A6A6A6',
    fontSize: '12px',
    marginBottom: 0
  },
  value: {
    fontWeight: 600,
    margin: 0
  }
}

const DescriptionList: React.FC<DescriptionListProps> = ({items}) => {
  return (
    <dl style={styles.list}>
      {items.map(({label, value}) => {
        const id = label.replaceAll(' ', '-')
        return (
          <div key={label}>
            <dd id={id} style={styles.label}>{label}</dd>
            <dt aria-labelledby={id} style={styles.value}>{value}</dt>
          </div>
        )
      })}
    </dl>
  )
}

export default DescriptionList
